module.exports = __webpack_public_path__ + "img/nginx.138ba682.svg";